/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const support_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m.75 12 5.31.542c.579.06 1.13.288 1.59.658l4.21 3.406c.525.407.85 1.036.885 1.717a1.486 1.486 0 0 1-.854 1.482 2.152 2.152 0 0 1-2.125-.19L7.038 17.83m5.506 1.632h7.24c.95-.013 2.544.537 2.544 2.148l-11.902 1.382a3.164 3.164 0 0 1-1.515-.274L.751 19m14.774-4L9.133 8.396a3.72 3.72 0 0 1-.708-4.326A3.779 3.779 0 0 1 11.2 2.049c1.2-.192 2.42.198 3.28 1.05l1.044 1.033 1.044-1.034a3.804 3.804 0 0 1 3.28-1.049 3.78 3.78 0 0 1 2.776 2.022 3.72 3.72 0 0 1-.708 4.324L15.525 15Z"
    />
  </svg>
)
export default support_medium
